<template>
  <div>
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >我的订单

      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%;"
          :header-cell-style="tableHeaderColor"
          :default-sort="{prop: 'date', order: 'descending'}"
        >
          <el-table-column
            prop="order_id"
            label="订单号"
            width="300"
          >
          </el-table-column>
          <el-table-column
            prop="service_name"
            label="服务名称"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
          >
          </el-table-column>

          <el-table-column
            prop="login_time"
            width="180"
            label="主体内容"
          >
          </el-table-column>
          <el-table-column
            prop="money"
            width="180"
            label="价格(元)"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">未付款</span>
              <span v-if="scope.row.status === 1">已付款</span>
              <span v-if="scope.row.status === 3">已取消</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                v-if="scope.row.status!=3"
                type="text"
                size="small"
              >取消</el-button>

            </template>
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-pagination
            background
            :page-size="pagesize"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="totalcount"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'OpenMyoeder',

  data () {
    return {
      pagesize: 10,
      pagenum: 1,
      totalcount: 0,
      time: '',
      startTime: '',
      endTime: '',
      tableData: [],

    };
  },

  mounted () {
    this.getMyOrder()
  },

  methods: {
    handleCurrentChange (val) {
      this.pagenum = val
      this.getMyOrder()
    },
    getMyOrder () {
      apis.index.myOrder({
        page: this.pagenum,
        page_size: this.pagesize
      }).then(res => {
        this.tableData = res.data.list
        /* this.tableData.forEach(element => {
          if (!element.isCancel) {
            element.isCancel = 0
          }
        }); */
        this.totalcount = parseInt(res.data.count)
      })
    },

    handleClick (row) {
      apis.index.cancelOrder({
        id: row.id
      }).then(res => {
        if (res.code == 1) {
          this.isCancel == 1
          this.getMyOrder()
        }

      })
    },
    tableHeaderColor ({ rowIndex, }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    },
  },

};
</script>
<style lang="scss" scoped>
.box-card {
  padding: 10px;
  background: #ffffff;

  .pager {
    margin-top: 10px;
    width: 100%;
    height: 64px;
    background: #ffffff;
    padding-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
}
</style>